// 页面配置
export default {
  common: {
    toBeSold: 'Coming soon',
  },
  courseList: {
    refunded: 'Refunded',
  },
  classCard: {
    registerStatus: {
      enrolNow: 'Enrol Now',
    },
  },
  couponList: {
    policyInfo: [
      `Only 1 coupon of the same category can be used for each order. Tuition vouchers can only be used to deduct tuition fees, and teaching materials vouchers can only be used to deduct teaching materials. 
      Coupons of different categories can be used at the same time.`,
      'Each coupon can only be applied to specific courses in coupon details.',
      'Coupon will no longer be available after expiration date.',
      `Coupon Return Policy: Coupon will be returned to customers if refund is requested before the first class (or after trial class, if applicable). 
      Coupons will not be returned for refund request after the start of the first class.`,
      'Coupons cannot be exchanged for cash at all time, and is for one time use only.',
      'For more information, please contact Think Academy customer service at: <p style="color:#222222;display:inline-block">Malaysia@tal.com</p>.',
    ],
  },
  unpaidDialog: {
    title: 'Go to Unpaid Courses to Enroll',
    visit1: 'Think Academy has recommended course(s) for you. Visit ',
    visit2: 'and complete payment to enroll.',
    contact: '',
    see: 'See Unpaid Courses',
    portal: 'Student Portal',
  },
  personalInfo: {
    title: 'Account Information',
  },
  payment: {
    tips: 'Installment payment requires you to authorize the auto-debit function(only stipe payment method ). Please note that the card has sufficient funds to avoid the seat being removed due to failure to pay on time.',
  },
};
